import styled from 'styled-components';

import { CompanyMessage } from '../../../../types/CompanyMessage';
import { GroupMessage } from '../../../../types/GroupMessage';
import { Tag } from '../../../cdl/Tag/Tag';
import { Text } from '../../../cdl/Text/Text';
import { formatCompanyName } from '../../../common/helpers/formatCompanyName.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';
import { theme } from '../../../common/ui/theme';

const CompanyList = styled.ul`
    position: relative;
    list-style: none;
    margin-left: ${theme.space[6]};

    &:before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        bottom: 12px;
        width: 1px;
        background-color: ${theme.colors.foreground.muted};
    }
`;

const CompanyListItem = styled.li`
    position: relative;
    margin-left: -2px;
    padding-left: 18px;
    color: ${theme.colors.foreground.muted};
    margin-bottom: ${theme.space[6]};

    &:before {
        content: '';
        position: absolute;
        left: 2px;
        top: 50%;
        transform: translateY(-50%);
        width: 10px;
        height: 1px;
        background-color: ${theme.colors.foreground.muted};
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

interface RoleDiagramProps {
    companies: CompanyMessage[];
    group: GroupMessage;
}

export const RoleDiagram = (props: RoleDiagramProps) => {
    return (
        <Box display="grid" gap={4}>
            <Box display="flex" gap={6} alignItems="center">
                <Text>{props.group?.name}</Text>
                <Tag variant="default">{translate('user.group')}</Tag>
            </Box>
            {props.companies.length > 0 ? (
                <CompanyList>
                    {props.companies.map((company) => (
                        <CompanyListItem key={company.id}>{formatCompanyName({ company })}</CompanyListItem>
                    ))}
                </CompanyList>
            ) : null}
        </Box>
    );
};
